import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import PlanIcon from '#components/svg/icons/NavVersetzungsplan'
import StyledText from '#components/a/StyledText'
import {routeKeys} from '#config/routeKeys'

export default class UpcommingChangeInAbteilungBenachrichtigungAzubi extends React.PureComponent {
  onClickNotification = () => {
    const {onNotificationClick} = this.props
    onNotificationClick(routeKeys.ablaufundtermine)
  }

  render() {
    const text = i18n.t('notification_text_will_change_abteilung_azubi')

    return (
      <button type="button" className="notification" onClick={this.onClickNotification}>
        <div className="notification__icon">
          <PlanIcon />
        </div>
        <StyledText text={text} modifier="notification" />
      </button>
    )
  }
}

UpcommingChangeInAbteilungBenachrichtigungAzubi.propTypes = {
  onNotificationClick: PropTypes.func.isRequired,
}
